import React from 'react';
import { motion } from 'framer-motion';
import { Palette, ShoppingCart, Search, Shield, ArrowRight } from 'lucide-react';
import { services } from '../../data/mock';

const iconMap = {
  Palette: Palette,
  ShoppingCart: ShoppingCart,
  Search: Search,
  Shield: Shield,
};

const Services = () => {
  return (
    <section id="services" className="py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <span className="text-cyan-500 text-sm font-semibold uppercase tracking-wider">Servicios</span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-navy-800 mt-3 mb-5">
            Nuestros Servicios
          </h2>
          <p className="text-slate-600 text-lg max-w-2xl mx-auto">
            Soluciones tecnológicas completas para impulsar tu transformación digital.
          </p>
        </motion.div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {services.map((service, index) => {
            const IconComponent = iconMap[service.icon];
            
            return (
              <motion.div
                key={service.id}
                className="group bg-white rounded-2xl p-8 border border-slate-200 hover:border-cyan-300 shadow-sm hover:shadow-xl hover:shadow-cyan-100/50 transition-all cursor-pointer"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                whileHover={{ y: -4 }}
              >
                {/* Icon */}
                <div className="w-14 h-14 rounded-xl bg-cyan-50 flex items-center justify-center mb-6 group-hover:bg-cyan-100 transition-colors">
                  {IconComponent && (
                    <IconComponent className="w-7 h-7 text-cyan-600" />
                  )}
                </div>

                {/* Content */}
                <h3 className="text-xl font-semibold text-navy-800 mb-3 group-hover:text-cyan-600 transition-colors">
                  {service.title}
                </h3>
                <p className="text-slate-600 mb-6 leading-relaxed">
                  {service.description}
                </p>

                {/* Features List */}
                <ul className="space-y-3 mb-6">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center gap-3 text-slate-600 text-sm">
                      <span className="w-1.5 h-1.5 rounded-full bg-cyan-500" />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>

                {/* CTA Link */}
                <div className="flex items-center gap-2 text-cyan-600 text-sm font-semibold group-hover:gap-3 transition-all cursor-pointer">
                  <span>Más información</span>
                  <ArrowRight className="w-4 h-4" />
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
